import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOpenapiinitiativeComponent } from './simple-icons-openapiinitiative.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOpenapiinitiativeComponent ],
    exports:      [ SimpleIconsOpenapiinitiativeComponent ],
    bootstrap:    []
})
export class SimpleIconsOpenapiinitiativeModule {}
